import Button from '@components/common/button';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import { JobTypeCode } from '@domain/constant/jobType';
import { JobGroupDto } from '@domain/rs/profile/career/JobGroupRs';
import { useJobGroupList } from '@repository/codes/useCodes';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { CommonCard } from '../../common/card';
import { InterviewVideoPlayer } from '../../common/video/player/interviewVideoPlayer';
import { Intention } from './components/intention';
import { QuestionTab } from './components/questionTab';
import styles from './result.module.scss';

const cx = classNames.bind(styles);

export const Result = () => {
  const updateSelectedQuestionSnByIndex = useInterviewPracticeStore((state) => state.updateSelectedQuestionSnByIndex);
  const selectedQuestionSn = useInterviewPracticeStore((state) => state.selectedQuestionSn);
  const questionDetails = useInterviewPracticeStore((state) => state.questionDetails);
  const practiceQuestionInfo = useInterviewPracticeStore((state) => state.practiceQuestionInfo, shallow);
  const questionDetailLoading = useInterviewPracticeStore((state) => state.questionDetailLoading);
  const { data: jobGroupData } = useJobGroupList();
  const jobGroupList = jobGroupData?.jobTitleGroups;
  const [enabled, setEnabled] = useState(false);
  const [selected, setSelected] = useState(0);
  const detail = questionDetails.get(selectedQuestionSn);

  const jobType = () => {
    if (!detail?.jobTypeCode) return '';

    switch (detail.jobTypeCode) {
      case JobTypeCode.NEW:
        return '신입';
      case JobTypeCode.CAREER:
        return '경력';
      case JobTypeCode.INTERNSHIP:
        return '인턴';
      default:
        return '';
    }
  };

  const jobGroup = () => {
    if (!detail?.jobGroupCode) return '';

    if (jobGroupList) {
      if (detail.jobGroupCode === -1) {
        return '직군 공통';
      } else {
        const idx = jobGroupList.findIndex((it: JobGroupDto) => it.code === detail.jobGroupCode);
        if (idx !== -1) {
          return jobGroupList[idx].name;
        }
      }
    }

    return '';
  };

  const selectQuestion = async (index: number) => {
    setSelected(index);
    await updateSelectedQuestionSnByIndex(index);
  };

  const handleClickClose = () => {
    window.close();
    setTimeout(() => alert('페이지를 벗어나시려면 우측 상단의 X 버튼을 클릭해 주세요.'), 100);
  };

  useEffect(() => {
    setTimeout(() => setEnabled(true), 100);
  }, []);

  if (!questionDetails.size) {
    return null;
  }
  return (
    <CommonCard className={cx('card', { enabled })} isScroll={false}>
      <Text fontStyle={FontStyle.H4_B}>수고하셨습니다! 면접 연습 결과를 확인하세요.</Text>
      <div className={cx('questionTab')}>
        <QuestionTab
          count={practiceQuestionInfo.practiceQuestions.length}
          onItemClicked={selectQuestion}
          selectedIndex={selected}
          loading={questionDetailLoading}
        />
      </div>
      <div className={cx('divider')} />

      <div className={cx('scrollArea')}>
        <div className={cx('scrollInner')}>
          <div className={cx('content')}>
            <div className={cx('questionInfo')}>
              <div className={cx('label')}>
                <span>{detail?.badgeTitle}</span>
                <span className={cx('item')}>{jobType()}</span>
                <span className={cx('item')}>{jobGroup()}</span>
              </div>

              <Text fontStyle={FontStyle.B2_B}>
                <span className={cx('emphasis')}>Q. </span>
                {detail?.questionText}
              </Text>
            </div>

            <InterviewVideoPlayer className={cx('videoArea')} source={detail?.answerVideoUrl ?? null} />

            <Intention data={detail} />
          </div>
        </div>
      </div>

      <div className={cx('footer')}>
        <Button onClick={handleClickClose} styles={{ width: 168, height: 48 }}>
          완료
        </Button>
      </div>
    </CommonCard>
  );
};
